import request from './adminRequest'

const careerMonitorApi = {
  listCareerMonitor (params) {
    return request.get('/careerMonitors', {params: params})
  },
  getCareerMonitor (id) {
    return request.get('/careerMonitors/' + id)
  },
  saveCareerMonitor (data) {
    return request.post('/careerMonitors', data)
  },
  updateCareerMonitor (id, data) {
    return request.put(`/careerMonitors/${id}`, data)
  },
  deleteCareerMonitor (id) {
    return request.delete('/careerMonitors/' + id)
  },
}

export default careerMonitorApi
